import AddressSearch from "../AddressSearch";

const AddressUnavailable = (props) => {
    return (<>
        <h1>Aw Shucks!</h1>
        <p>It doesn't look like we are coming to your neighborhood. Unfortunately, our services aren't available at that address. Try a new address.</p>
        <AddressSearch/>
    </>)
};

export default AddressUnavailable;
